<div class="content-wrapper">
    <div class="card">
      <div class="card-body">
        <div class="row separator ">
            <div class="col-md-6">
              <div class="pull-left">
                <button class="btn btn-primary" (click)="openCourtModal(0)">Add New Court</button>
              </div>
            </div>
            <div class="col-md-6">
            </div>
        </div>
        <div class="row" *ngIf="courts != null">
          <div class="col-12 table-responsive" >
            <div class="row">
              <div class="col-md-12">
                <div style="float: right;">
                  <mat-form-field class="small-text">
                    <input matInput (keyup)="applyFilter($event.target.value)"  placeholder="Filter Table">
                  </mat-form-field>
                </div>
              </div>
            </div>
            <table mat-table [dataSource]="datasource" class="table">
              <ng-container matColumnDef="courtName">
                <th mat-header-cell *matHeaderCellDef>Court Name</th>
                <td mat-cell *matCellDef="let row">{{row.courtName}}</td>
              </ng-container>
  
              
              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>Address</th>
                <td mat-cell *matCellDef="let row">{{row.address}}</td>
              </ng-container>
  
              
              <ng-container matColumnDef="postcode">
                <th mat-header-cell *matHeaderCellDef>Postcode</th>
                <td mat-cell *matCellDef="let row">{{row.postcode}}</td>
              </ng-container>
              <ng-container matColumnDef="telephone">
                <th mat-header-cell *matHeaderCellDef>Telephone</th>
                <td mat-cell *matCellDef="let row">{{row.telephone}}</td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let row">{{row.email}}</td>
              </ng-container>
              <ng-container matColumnDef="fax">
                <th mat-header-cell *matHeaderCellDef>Fax</th>
                <td mat-cell *matCellDef="let row">{{row.fax}}</td>
              </ng-container>
              <ng-container matColumnDef="dateAdded">
                <th mat-header-cell *matHeaderCellDef>Date Added</th>
                <td mat-cell *matCellDef="let row">{{ row.dateAdded | date : 'd/M/yy, h:mm a' }}</td>
              </ng-container>
              <ng-container matColumnDef="addedBy">
                <th mat-header-cell *matHeaderCellDef>Added By</th>
                <td mat-cell *matCellDef="let row">{{ row.username}}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">
                    <labe class="badge badge-{{row.status-color}}">{{row.statusText}}</labe>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let row">
                  <button class="btn btn-outline-primary" (click)="openCourtModal(row.id)">Edit</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <mat-paginator class="pull-right" #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 15, 25, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>
        </div>
        <app-nodata *ngIf="!courts"></app-nodata>
      </div>
    </div>
  </div>